import React from 'react';
import { ts } from 'src/utils/translate';
import { genericOKCancelSwal } from 'src/utils/swal';
import { IconButton, Tooltip } from "@mui/material";
import { TrashIcon } from "src/icons/quote/TrashIcon";

export const DeleteButton = (
    {
      title,
      deleteCustomRow,
      table,
      row,
    }: {
      title: string;
      deleteCustomRow: any;
      table: any;
      row: any;
    }
) => {

  let confirmMsg = ts("are_you_sure_to_delete", "Are you sure you want to delete the item?");

  // speciális munkadíj esetén más a szöveg
  if (
      row && row.specification_type
      && (row.specification_type === "installation" || row.specification_type === "personalisation")
  ) {
    confirmMsg = ts("are_you_sure_to_delete_cant_undo", "Are you sure want to continue? This action cannot be undone.");
  }

  return (
      <Tooltip title={title}>
        <IconButton
            onClick={(_) => {
              genericOKCancelSwal(
                  confirmMsg,
                  "OK",
                  () => deleteCustomRow(row, table.entitytype),
                  () => {
                  },
                  ts("plt_cancel", "Cancel"),
                  ts("attention", "Attention!")
              );
            }}
        >
          <TrashIcon/>
        </IconButton>
      </Tooltip>
  )
};
